"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var pinata_1 = require("@snoam/pinata");
var NameOnDoor = (function (_super) {
    __extends(NameOnDoor, _super);
    function NameOnDoor(props) {
        var _this = _super.call(this, props) || this;
        _this.onNameOnDoorChange = function (e) {
            var currentValue = e.target.value;
            _this.setState({
                errorMsg: currentValue.length > 25 ? 'Maks 25 tegn' : '',
                validMsg: currentValue && currentValue.length > 0 ? ' ' : '',
                value: currentValue,
            });
            _this.props.updateNameOnDoor(currentValue);
        };
        _this.state = {
            errorMsg: '',
            value: props.nameOnDoor,
            validMsg: props.nameOnDoor || '',
        };
        return _this;
    }
    NameOnDoor.prototype.render = function () {
        var _this = this;
        var _a = this.state, value = _a.value, errorMsg = _a.errorMsg, validMsg = _a.validMsg;
        var _b = this.props, clearable = _b.clearable, showErrors = _b.showErrors;
        return (React.createElement(pinata_1.Input, { autoComplete: "false", type: 'text', value: value, onChange: function (e) { return _this.onNameOnDoorChange(e); }, label: 'Navn på dør / Postkasse', validMsg: showErrors && validMsg, errorMsg: showErrors && errorMsg, clearable: clearable }));
    };
    return NameOnDoor;
}(React.PureComponent));
exports.default = NameOnDoor;
//# sourceMappingURL=NameOnDoor.js.map